import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import AccountDeactivation from "./pages/AccountDeactivation";

function App() {
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipod|windows phone/i.test(userAgent);
    const isTablet = /ipad|tablet/i.test(userAgent);

    if (isMobile || isTablet) {
      // Preserve the original path when redirecting
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = `https://m.frissly.com${currentPath}`;
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/TermsConditions" element={<TermsConditions />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/RefundPolicy" element={<RefundPolicy />} />
        <Route path="/AccountDeactivation" element={<AccountDeactivation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
